import UserAvatar from '../atoms/UserAvatar'

const UserItem = () => {
  return (
    <article className="user-item">
      <UserAvatar picture="https://i.pravatar.cc/300" />
      <div>
        <p>Walter Andrés</p>
        <p className="sub-content">5 de Agosto</p>
      </div>
    </article>
  )
}

export default UserItem
